var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.cv)?_c('div',[(_vm.type === '0')?_c('n-r-project-edit',{attrs:{"edit":true,"cv":_vm.cv,"atsCvId":_vm.atsCvOutId,"clientType":_vm.clientType},on:{"save":_vm.onSave}}):_vm._e(),(_vm.type === '1')?_c('n-r-attachment-edit',{attrs:{"cv":_vm.cv,"atsCvId":_vm.atsCvOutId,"clientType":_vm.clientType}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }